"use strict";

export enum StateValues {
	ON = "on",
	OFF = "off"
}
